import { ResetPasswordForm } from "./ResetPasswordForm";
import { useModalContext } from "../../modals";
import { DefaultModal } from "../../modals/material/DefaultModal";

export const ResetPasswordModal = () => {
  const { closeModal } = useModalContext();

  return (
    <DefaultModal
      onClose={() => {
        closeModal();
      }}
      showBottomsheetOnlyForMobile
      className={"max-h-64 h-64 lg:max-h-96 lg:px-20"}
    >
      <ResetPasswordForm />
    </DefaultModal>
  );
};
